import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Video, VideoProvider, VideoService } from '@fgb/core';
import { Observable } from 'rxjs';
import {
  BoxcastPlayerComponent,
  StreamablePlayerComponent,
  StreamAMGPlayerComponent,
  TwitchPlayerComponent,
  VimeoPlayerComponent,
  YoutubePlayerComponent,
} from '@fgb/portal-component-library/src/lib/providers/video';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';

@Component({
  selector: 'fgbcl-video-player',
  standalone: true,
  imports: [
    CommonModule,
    PipesModule,
    BoxcastPlayerComponent,
    VimeoPlayerComponent,
    StreamablePlayerComponent,
    TwitchPlayerComponent,
    StreamAMGPlayerComponent,
    YoutubePlayerComponent,
  ],
  templateUrl: './video-player.component.html',
  styleUrl: './video-player.component.scss',
})
export class VideoPlayerComponent implements OnChanges {
  @Input({ required: true }) videoId: number;
  @Input() allowPlayback: boolean = true;
  private readonly videoService = inject(VideoService);
  video$: Observable<Video>;
  provider = VideoProvider;
  showThumbnail: boolean = true;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['videoId']) {
      this.video$ = this.videoService.getVideo(this.videoId);
    }
  }

  playVideo() {
    this.showThumbnail = false;
  }
}
